import { type InfiniteData } from '@tanstack/react-query';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';
import { type ISimilarOffersSearchResultSchema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/SimilarOffersSearchResultSchema';

export function infiniteOffersDataToOffers(
  data: InfiniteData<ISimilarOffersSearchResultSchema>,
): IOfferForDesktopEnrichedV3Schema[] {
  return data.pages.flatMap(page => page.offers);
}
